import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=6e209a3e&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e209a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e209a3e')) {
      api.createRecord('6e209a3e', component.options)
    } else {
      api.reload('6e209a3e', component.options)
    }
    module.hot.accept("./Number.vue?vue&type=template&id=6e209a3e&scoped=true", function () {
      api.rerender('6e209a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/components/questionTypes/Number.vue"
export default component.exports